const YOUTUBE_ID_REGEXP =
  /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/gi;

export function getIdFromURL(url) {
  let id = url.replace(YOUTUBE_ID_REGEXP, '$1');

  if (id.includes(';')) {
    const pieces = id.split(';');
    if (pieces[1].includes('%')) {
      const uriComponent = decodeURIComponent(pieces[1]);
      id = `http://youtube.com${uriComponent}`.replace(YOUTUBE_ID_REGEXP, '$1');
    } else {
      id = pieces[0];
    }
  } else if (id.includes('#')) {
    id = id.split('#')[0];
  }

  return id;
}
